<template>
  <p class="price">{{ text }}</p>
</template>

<script>
export default {
  props: {
    text: String,
  },
};
</script>

<style scoped>
.price {
  font-size: 20px;
  font-weight: 700;
  color: #ffffff;
  font-style: normal;
}
</style>



// WEBPACK FOOTER //
// Content/src/components/MyProgress/Daccord/FlagText.vue